import { List } from "@/components/List";
import { StructureEvents } from "@/endpoints/dryp/event";
import { getCoreRowModel, Row, useReactTable } from "@tanstack/react-table";
import { FC } from "react";
import { EventColumns } from "./EventColumns";

interface EventsListProps {
	row: Row<StructureEvents>;
}

export const EventsList: FC<EventsListProps> = ({ row }) => {
	const table = useReactTable({
		data: row.original.events,
		columns: EventColumns,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<List
			pagination={undefined}
			table={table}
			layout={{ loading: false, className: "-mt-2 ", tableWrapperClassName: "rounded-none" }}
		/>
	);
};
